module.exports = __webpack_public_path__ + "media/images/puerta-riel-49620079f854c5ff0d5d41af2ad1eacb.png";